import { render, staticRenderFns } from "./getayandebestankar.vue?vue&type=template&id=3a0e2f0c"
import script from "./getayandebestankar.vue?vue&type=script&lang=js"
export * from "./getayandebestankar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports